import React, { useEffect, useContext } from 'react';
import { useFavoritesRowQuery } from '../../../client/query/favorites';
import { useGetContinueSeriesRow } from '../../../client/query/continue-series';
import { useMyWorkoutsRowQuery } from '../../../client/query/my-workouts';
import './index.scss';
import ScrollingSection from '../../../components/scrolling-section';
import { setToolbarTitle } from '../../../store/to-native';
import { NotFound } from '../../../helpers/not-found';

import {
  myListTitle,
  myWorkoutsTitle,
  continueSeriesAndChallengesTitle,
  myFavoritesTitle,
} from '../../../i18n/translations';
import { getSearchState } from '../../search/state/search-state';
import { useEquipmentType } from '../../../client/query/equipment-type';
import { useConfig } from '../../../store/reducers/config';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { setThemeClass } from '@ifit/themes/setThemeClass';

export const MyList: React.FC = () => {
  const context = useContext(ThemeContext);

  useEffect(() => {
    getSearchState().setViewContext({});
    setToolbarTitle(myListTitle());
  }, []);

  useEffect(() => {
    setThemeClass(context);
  }, [context]);

  const { equipmentType } = useEquipmentType();
  const { isLoggedIn } = useConfig();

  const {
    data: continueSeriesData,
    isLoading: continueSeriesLoading,
    isError: continueSeriesError,
  } = useGetContinueSeriesRow();

  const {
    data: favoritesData,
    isLoading: favoritesLoading,
    isError: favoritesError,
  } = useFavoritesRowQuery();

  const {
    data: myWorkoutsData,
    isLoading: myWorkoutsLoading,
    isError: myWorkoutsError,
  } = useMyWorkoutsRowQuery();

  const isStrength = equipmentType === 'Strength';
  if (!isLoggedIn) {
    return <NotFound />;
  }
  return (
    <div className="my-list-view" data-testid="my-list-view">
      {!continueSeriesError && (
        <ScrollingSection
          title={continueSeriesAndChallengesTitle()}
          isLoading={continueSeriesLoading}
          listData={continueSeriesData}
          route={'/continue-series'}
        />
      )}
      {!favoritesError && (
        <ScrollingSection
          showCategory
          title={myFavoritesTitle()}
          listData={favoritesData}
          route={'/favorites'}
          isLoading={favoritesLoading}
        />
      )}
      {equipmentType && !isStrength && !myWorkoutsError && (
        <ScrollingSection
          title={myWorkoutsTitle()}
          isLoading={myWorkoutsLoading}
          listData={myWorkoutsData}
          route={'/my-workouts'}
        />
      )}
    </div>
  );
};

export default MyList;
